import React from 'react';
import PageLayout from 'components/common/PageLayout';
import { CompanyChangeBlur } from 'components/common';
import useTokenValidation from 'hooks/useTokenValidation';
import EstoqueOperacional from '../components/EstoqueOperacional';

/**
 * Página da diretoria de Estoque.
 *
 * A checagem de permissão e a navegação entre sub-abas já vivem no EstoqueOperacional, que era
 * montado pela aba do Operacional. A página só acrescenta o que era responsabilidade daquela
 * página: validação de token e o layout.
 */
const Estoque = () => {
  useTokenValidation();

  return (
    <>
      <CompanyChangeBlur />
      <PageLayout>
        <div className="w-full sm:p-6">
          <EstoqueOperacional />
        </div>
      </PageLayout>
    </>
  );
};

export default Estoque;
